// For completely inscrutable reasons, neither of these work if you import from
// utils directly ¯\_(ツ)_/¯
import { getHtmlDateString } from "../utils/getHtmlDateString/getHtmlDateString";
import { today } from "../utils/today";
import { UserDetails } from "../AppDataProvider/types";

export const userDetailsStripeInvoice: UserDetails = {
  crmFieldData: {
    date_field: getHtmlDateString(today),
    optional_field: null,
    text_field: "this is a text field",
  },
  email: "eab@appointedd.com",
  firstName: "Eric",
  lastName: "Blair",
  marketingOptIn: false,
  phone: "+441234567890",
};
export const userDetailsStripeInvoiceWithoutCrmData: UserDetails = {
  email: userDetailsStripeInvoice.email,
  firstName: userDetailsStripeInvoice.firstName,
  lastName: userDetailsStripeInvoice.lastName,
  marketingOptIn: false,
  phone: userDetailsStripeInvoice.phone,
};

export const userDetailsSquareInvoice: UserDetails = {
  crmFieldData: {
    date_field: getHtmlDateString(today),
    optional_field: null,
    text_field: "this is a text field",
  },
  email: "cruyff@appointedd.com",
  firstName: "Johan",
  lastName: "Cruyff",
  marketingOptIn: false,
  phone: "+440234567150",
};
export const userDetailsSquareInvoiceWithoutCrmData: UserDetails = {
  email: userDetailsSquareInvoice.email,
  firstName: userDetailsSquareInvoice.firstName,
  lastName: userDetailsSquareInvoice.lastName,
  marketingOptIn: false,
  phone: userDetailsSquareInvoice.phone,
};
